var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dinner-ideas-wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "dinner-ideas" }, [
      _c("div", { staticClass: "ideas-sidebar" }, [
        _c(
          "div",
          { staticClass: "ideas-menu" },
          _vm._l(_vm.dinnerIdeas, function(idea) {
            return _c(
              "a",
              {
                class: { active: idea == _vm.activeIdea },
                attrs: { href: _vm.getLink(idea) },
                on: {
                  mouseenter: function($event) {
                    return _vm.setActive(idea)
                  },
                  mouseleave: function($event) {
                    _vm.hovering = false
                  }
                }
              },
              [
                _c("h4", { domProps: { innerHTML: _vm._s(idea.title) } }),
                _vm._v(" "),
                _c("h5", { domProps: { innerHTML: _vm._s(idea.subtitle) } }),
                _vm._v(" "),
                _c("h6", { domProps: { innerHTML: _vm._s(idea.price) } })
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ideas-content" },
        _vm._l(_vm.dinnerIdeas, function(idea) {
          return _c(
            "div",
            {
              staticClass: "active-idea",
              class: { active: idea == _vm.activeIdea }
            },
            [
              _c("div", { staticClass: "active-idea-image" }, [
                _c("img", {
                  attrs: { src: idea.image.sizes.medium_large, alt: idea.title }
                })
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "active-idea-content",
                  attrs: { href: _vm.getLink(idea) }
                },
                [
                  _c("h3", { domProps: { innerHTML: _vm._s(idea.title) } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rating" },
                    _vm._l(parseInt(idea.rating), function(i) {
                      return _c("font-awesome-icon", {
                        key: "star-" + i,
                        attrs: { icon: "star" }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "body",
                    domProps: { innerHTML: _vm._s(idea.body) }
                  })
                ]
              )
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "page-section-header",
        staticStyle: { "margin-top": "40px", "margin-bottom": "0" }
      },
      [_c("h3", [_vm._v("meals with a kick")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/EatDrinkFeatured.vue?vue&type=template&id=e6316de8&
// module id = 409
// module chunks = 0